/* eslint-disable prefer-promise-reject-errors */
type FaxiosOptions = {
  headers?: { [key: string]: string };
  validateStatus?: (status: number) => boolean;
};

const request = async (
  url: string,
  fetchOptions: RequestInit,
  axiosOptions: Pick<FaxiosOptions, 'validateStatus'>
): Promise<{
  status: number;
  data: any;
  headers: Record<string, string>;
  statusText: string;
}> => {
  const requestInit = {
    ...fetchOptions,
  };

  if (
    typeof fetchOptions.body !== 'undefined' &&
    fetchOptions.headers?.['content-type']?.startsWith('application/json')
  ) {
    requestInit.body = JSON.stringify(requestInit.body);
  }

  const response = await fetch(url, requestInit).catch((error) => Promise.reject({ request: error }));

  const isJson = response.headers.get('content-type')?.startsWith('application/json');

  const data = isJson ? await response.json() : await response.text();

  const headers: Record<string, string> = {};

  response.headers.forEach((value, key) => {
    headers[key] = value;
  });

  const responseData = {
    data,
    status: response.status,
    statusText: response.statusText,
    headers,
  };

  if (axiosOptions.validateStatus) {
    if (axiosOptions.validateStatus(response.status)) {
      return Promise.resolve(responseData);
    }

    return Promise.reject({ response: responseData });
  } else if (response.status < 300) {
    return Promise.resolve(responseData);
  }

  return Promise.reject({ response: responseData });
};

/**
 * A tiny and incomplete wrapper around fetch with the axios API
 * Only supports json and text content types, and a few options
 *
 * Used for the leaseApi
 */
export const faxios = {
  post: (url: string, body: any, options: FaxiosOptions = {}) =>
    request(
      url,
      {
        method: 'POST',
        body,
        headers: options.headers,
      },
      {
        validateStatus: options.validateStatus,
      }
    ),
  delete: (url: string, options: FaxiosOptions = {}) =>
    request(
      url,
      {
        method: 'DELETE',
        headers: options.headers,
      },
      {
        validateStatus: options.validateStatus,
      }
    ),
};
